/**
 * Deriva una etiqueta corta y legible a partir de una URL, para mostrar
 * enlaces como chips en lugar de "enlace 1", "enlace 2"...
 */

const KNOWN_HOSTS = [
  [/(^|\.)(youtube\.com|youtu\.be)$/i, "Vídeo", "video"],
  [/(^|\.)(loom\.com|vimeo\.com|wistia\.com)$/i, "Vídeo", "video"],
  [/(^|\.)drive\.google\.com$/i, "Drive", "folder"],
  [/(^|\.)docs\.google\.com$/i, "Documento", "doc"],
  [/(^|\.)sheets\.google\.com$/i, "Hoja", "sheet"],
  [/(^|\.)slides\.google\.com$/i, "Presentación", "doc"],
  [/(^|\.)notion\.so$/i, "Notion", "doc"],
  [/(^|\.)figma\.com$/i, "Figma", "doc"],
  [/(^|\.)dropbox\.com$/i, "Dropbox", "folder"],
  [/(^|\.)canva\.com$/i, "Canva", "doc"],
];

/** Convierte "panel.seranking.com" en "Seranking". */
const hostnameToName = (hostname) => {
  const parts = hostname.replace(/^www\./i, "").split(".").filter(Boolean);
  const base = parts.length >= 2 ? parts[parts.length - 2] : parts[0] || "";
  if (!base) return "Enlace";
  return base.charAt(0).toUpperCase() + base.slice(1);
};

/**
 * @returns {{ label: string, kind: "video"|"doc"|"sheet"|"folder"|"link" }}
 */
export const getLinkLabel = (rawUrl = "") => {
  const trimmed = String(rawUrl).trim();
  if (!trimmed) return { label: "Enlace", kind: "link" };

  const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed.replace(/^\/\//, "")}`;

  let hostname;
  try {
    hostname = new URL(withProtocol).hostname;
  } catch {
    return { label: "Enlace", kind: "link" };
  }

  for (const [pattern, label, kind] of KNOWN_HOSTS) {
    if (pattern.test(hostname)) return { label, kind };
  }

  return { label: hostnameToName(hostname), kind: "link" };
};
